import * as React from "react";
import type { SVGProps } from "react";

interface FinishProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Finish = ({ cancelled = false, ...props }: FinishProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M11.518 2.946c.32.126.628.27.995.466l.416.233.727.43c1.2.706 2.023 1.058 3.253 1.387a9.2 9.2 0 0 0 2.498.322l.334-.01c1.206-.115 2.267.78 2.367 2.019l.005.15v.172l-.025.195-2.177 8.122a2.18 2.18 0 0 1-1.753 1.59l-.457.074c-1.607.236-2.986.206-4.149-.106-1.274-.341-2.105-.727-3.364-1.555l-.917-.615c-.549-.36-.871-.54-1.307-.732l-.215-.09c-.45-.178-1.08-.37-1.87-.566l-.223-.054-1.408 5.26a1.4 1.4 0 0 1-1.583 1.019l-.132-.029a1.4 1.4 0 0 1-.99-1.714L4.585 7.566l.006-.013 1.025-3.825.069-.27.076-.189c.657-1.143 1.328-1.548 2.395-1.294l.167.04c1.368.32 2.426.627 3.195.93"
        />
        <path
          fill="#000"
          d="M11.243 3.643c.291.115.573.247.904.424l.401.224.728.43c1.246.734 2.131 1.115 3.439 1.466.916.245 1.832.36 2.719.346l.377-.013a1.42 1.42 0 0 1 1.548 1.299l.004.125v.172l-2.176 8.122a1.43 1.43 0 0 1-1.15 1.043l-.445.073c-1.499.22-2.782.197-3.846-.088-1.2-.322-1.958-.676-3.14-1.454l-.923-.619c-.586-.384-.943-.583-1.43-.797l-.227-.095c-.542-.215-1.307-.441-2.284-.674l-.622-.143-1.597 5.96a.65.65 0 1 1-1.255-.336L5.296 7.806l.02-.058 1.027-3.836.069-.27c.503-.876.869-1.104 1.571-.938l.17.04q1.99.466 3.09.9"
        />
        <path
          fill="#FFF"
          d="M10.766 4.853c.245.096.483.208.747.349l.375.21.728.428c1.277.753 2.273 1.203 3.762 1.603q1.77.474 3.556.371a.12.12 0 0 1 .13.11v.022l-2.133 7.956a.13.13 0 0 1-.106.097l-.421.07q-2.018.292-3.321-.059c-1.079-.289-1.712-.593-2.753-1.278l-.933-.625c-.634-.417-1.056-.653-1.644-.911l-.249-.104q-.914-.36-2.471-.732l-.57-.13 2.14-7.998.064-.253a.013.013 0 0 1 .016-.01l.173.041q1.914.45 2.91.843"
        />
      </g>
      <g fill="#000">
        <path d="m5.159 9.478 2.897.776-.776 2.898-2.898-.777zM8.833 7.356l2.898.777-.777 2.898-2.898-.777z" />
        <path d="m10.954 11.03 2.898.777-.776 2.898-2.898-.777zM13.076 14.705l2.897.776-.517 1.932-2.898-.776z" />
        <path d="m16.75 12.584 2.898.776-.777 2.898-2.898-.777zM14.628 8.91l2.898.776-.776 2.898-2.898-.777zM18.303 6.788l2.897.776-.776 2.898-2.898-.776zM6.712 3.682l2.897.777-.776 2.897-2.898-.776zM12.507 5.235l2.898.777-.777 2.897-2.897-.776z" />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Finish;
